var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"dashboard"}},[_c('div',{staticClass:"dashboard_menu"},[_c('DashboardMenu')],1),_vm._v(" "),_c('div',{staticClass:"dashboard_main"})])}
var staticRenderFns = []

export { render, staticRenderFns }